import classNames from 'classnames';
import './InputAdornment.scss';
import { IconType } from 'react-icons';
import { ReactNode } from 'react';

interface InputAdornmentProps {
    position: 'start' | 'end';
    text?: string;
    Icon?: IconType;
    children?: ReactNode;
}

export function InputAdornment({ position, text, Icon, children }: InputAdornmentProps) {
    return (
        <div className={classNames('InputAdornment', `InputAdornment--${position}`)}>
            {text == null ? null : <label>{text}</label>}
            {Icon == null ? null : <Icon className="InputAdornment__icon" />}
            {children}
        </div>
    );
}
